import Link from "next/link";
import React from "react";
import ArrowRight from "../svg/ArrowRight";
import styles from "./sitemap.module.scss";

export type LinkT = {
  title: string;
  url?: string;
};

interface BreadcrumbProps {
  links: LinkT[];
}

const Breadcrumb = ({ links }: BreadcrumbProps) => (
  <div className={styles.breadcrumbContainer}>
    {links.map((link) => {
      if (link.url) {
        return (
          <React.Fragment key={link.title}>
            <Link className={styles.link} key={link.title} href={link.url}>
              {link.title}
            </Link>

            <div className={styles.icon}>
              <ArrowRight />
            </div>
          </React.Fragment>
        );
      }
      return (
        <p className={styles.title} key={link.title}>
          {link.title}
        </p>
      );
    })}
  </div>
);

export default Breadcrumb;
